/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DisableBranchReasonAdminDto } from '../models/DisableBranchReasonAdminDto';
import type { DisableBranchReasonAdminListedDtoAdmin } from '../models/DisableBranchReasonAdminListedDtoAdmin';
import type { PostDisableBranchReasonRequestAdmin } from '../models/PostDisableBranchReasonRequestAdmin';
import type { PutDisableBranchReasonRequestAdmin } from '../models/PutDisableBranchReasonRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DisableBranchReasonsService {
    /**
     * **Required Policy:** `ManageDisableBranchReasons`
     * @returns DisableBranchReasonAdminDto OK
     * @throws ApiError
     */
    public static createDisableBranchReasonAsyncAdmin({
        requestBody,
    }: {
        requestBody?: PostDisableBranchReasonRequestAdmin,
    }): CancelablePromise<DisableBranchReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/disablebranchreasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDisableBranchReasons`
     * @returns DisableBranchReasonAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static getDisableBranchReasonsAsyncAdmin(): CancelablePromise<DisableBranchReasonAdminListedDtoAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/disablebranchreasons',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDisableBranchReasons`
     * @returns DisableBranchReasonAdminDto OK
     * @throws ApiError
     */
    public static updateDisableBranchReasonAsyncAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutDisableBranchReasonRequestAdmin,
    }): CancelablePromise<DisableBranchReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/disablebranchreasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteDisableBranchReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDisableBranchReasonAsyncAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/disablebranchreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDisableBranchReasonDetails`
     * @returns DisableBranchReasonAdminDto OK
     * @throws ApiError
     */
    public static getDisableBranchReasonByIdAsyncAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<DisableBranchReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/disablebranchreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
